import React from 'react';

import { Text, Box, xcss } from '@atlaskit/primitives';

const generalContentStyles = xcss({
	marginTop: 'space.400',
});

export const GeneralPageContent = () => {
	return (
		<Box xcss={generalContentStyles}>
			<Text>General page content here</Text>
		</Box>
	);
};
